<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill_link`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.561 4.24609C14.0996 4.24622 15.347 5.49364 15.3472 7.03223V8.96777C15.3471 10.5065 14.0997 11.7538 12.561 11.7539C11.6438 11.7539 10.8302 11.3107 10.3225 10.6268C9.738 9.83946 8.98035 8.96973 7.99977 8.96973C7.01898 8.96973 6.26115 9.83985 5.67636 10.6272C5.16859 11.3109 4.35491 11.7539 3.43799 11.7539C1.89984 11.7537 0.652954 10.5069 0.652832 8.96875V7.03125C0.653092 5.49321 1.89993 4.24627 3.43799 4.24609C4.35485 4.24609 5.16848 4.68914 5.67626 5.3728C6.26107 6.16018 7.01896 7.03027 7.99977 7.03027C8.98038 7.03027 9.73808 6.16059 10.3226 5.37321C10.8303 4.6893 11.6439 4.24609 12.561 4.24609Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillLink',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
